MaterialTextfield.prototype.checkValidity = function () {
    if (this.input_.validity) {
        if (this.input_.validity.valid || this.input_.validity.valueMissing) {
            this.element_.classList.remove(this.CssClasses_.IS_INVALID);
            if(!this.input_.validity.valueMissing) {
                this.element_.classList.remove('is-missing');
            }
        } else {
            this.element_.classList.remove('is-smarty-invalid');
            this.element_.classList.add(this.CssClasses_.IS_INVALID);
        }
    }
};

MaterialTextfield.prototype.onBlur_ = function(event) {
    const layout = document.getElementsByClassName('mdl-layout');
    const upgraded = document.getElementsByClassName('mdl-layout is-upgraded');

    if(layout.length !== upgraded.length) {
        // Since the Layout-Upgrade restructures the dom, this fires blur-events. We only want to catch those events
        // that are fired after all mdl-layout-Elements have been upgraded
        return;
    }

    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
    if (this.input_.validity) {
        if (this.input_.validity.valueMissing) {
            this.element_.classList.add('is-missing');
            this.element_.classList.remove('is-smarty-invalid');
        } else {
            this.element_.classList.remove('is-missing');
        }
    }
};

MaterialTextfield.prototype.updateClasses_ = function (e) {
    // Die eigentliche Funktion welche die MDL-Validierung durchführt
    const runCheck = function() {
        this.checkDisabled();
        this.checkValidity();
        this.checkDirty();
        this.checkFocus();
    };

    // Es wird geprüft ob der Parameter e gesetzt ist und dieser ein Typ hat, in dem Fall handelt es sich um ein event.
    if(e && e.type) {
        // Falls e ein Event ist, wurde diese Funktion als callback eines EventListeners aufgerufen wurde, in dem Fall
        // wird ein debounce eingebaut (damit z.B. die Validierung erst nach dem Ende der EIngabe passiert)
        debounce(runCheck.bind(this), 400)();
    } else {
        // Falls diese Funktion direkt aufgerufen wurde wird kein debounce eingebaut
        runCheck.bind(this)();
    }

};
